import React from 'react';
import SEO from '../../common/SEO';
import HeaderTwo from '../../common/header/HeaderTwo';
import BannerThree from '../../components/programs/Employers/BannerThree';
import HomeThreeService from '../../components/programs/Employers/HomeThreeService';
import AboutFive from '../../components/programs/Employers/AboutFive';
import AboutTwo from '../../components/programs/Employers/AboutTwo';
import TestimonialSectionTwo from '../../components/programs/Employers/TestimonialSectionTwo';
import FooterTwo from '../../common/footer/FooterTwo';
import { useTranslation } from 'react-i18next';

const Employers = () => {
        const { t } = useTranslation()
        return (
        <>
            <SEO title={t('seoEmployers')} />
             
            <HeaderTwo styles="header-transparent header-style-2" searchDisable buttonStyle="bg-color-white" />

            <BannerThree />

            <AboutFive />

            <AboutTwo />

            <TestimonialSectionTwo />

            <FooterTwo />
        </>
    )
}

export default Employers;